export default {
      id: "icon-home-usage",
      viewBox: "0 0 640 512",
      url: __webpack_public_path__ + "icons.svg#icon-home",
      toString: function () {
        return this.url;
      }
    }